import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import "./i18n"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.Fragment>
    <BrowserRouter>
      <div translate="no" lang="pt-br" className="notranslate">
        <App />
      </div>
    </BrowserRouter>
  </React.Fragment>
)
